import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from '@core/components/loader/loader.component';
import { PushNotificationService } from '@services/notification/push-notification.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'hms | Portal';

  constructor(
    private pushNotificationService: PushNotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Listen to push notification clicks when the app initializes
    this.pushNotificationService.listenToNotificationClicks((fullUrl, rawUrl) => {
      if (rawUrl.startsWith('/')) {
        this.router.navigateByUrl(rawUrl);
      } else {
        window.open(fullUrl, '_blank');
      }
    });
  }
}
